export enum FormBlankPageOrientation {
  portrait = 0,
  landscape = 1,
}
